import axiosInstance from './axiosInstance';

// AFA tariff rates (General Settings). GET is open to any authenticated user
// (the RSC needs the current rate); SAVE is Super-Admin only (enforced server-side).
export const getAfaSettings = () => axiosInstance.get('/GeneralSettings/GetAfa');
export const saveAfaSettings = (data) => axiosInstance.post('/GeneralSettings/SaveAfa', data);
